import { useAppDispatch } from '@/app/hooks';
import { ButtonComponent } from '@/components/Button/Button';
import { clearQuery } from '@/features/filterSlice';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import type { StackProps } from '@mantine/core';
import { Box, Stack } from '@mantine/core';

export function ClearFilter(props: StackProps) {
  const intl = useClientTerminology();
  const dispatch = useAppDispatch();

  return (
    <Stack style={{ order: 2 }} align="start" {...props}>
      <Box>
        {intl.formatMessage({
          id: 'list.noResultsWithActiveFilters',
        })}
      </Box>
      <ButtonComponent
        id="clear-button"
        data-testid="clear-filter-button"
        variant="secondary"
        label={intl.formatMessage({ id: 'list.clearFilterButton' })}
        onClick={() => dispatch(clearQuery())}
      />
    </Stack>
  );
}
